import { alpha, styled } from '@mui/material';
import classNames from 'classnames';
import { UrlMetadataResult } from 'src/@types/url';
import { UrlMetadata } from '../private/components/UrlMetadata';
import { EmbedMetadataProps } from './types';

export const EmbedMetadata = ({
  url,
  onMetadataChange,
  metadata,
  selected,
}: EmbedMetadataProps<UrlMetadataResult>) => {
  if (!url) return null;

  if (!url.includes('@') && !url.startsWith('http')) {
    url = `https://${url}`;
  }

  return (
    <StyledUrlMetadata
      draggable="false"
      url={url}
      metadata={metadata}
      onMetadataChange={onMetadataChange}
      className={classNames({ selected })}
    />
  );
};

const StyledUrlMetadata = styled(UrlMetadata)(({ theme }) => ({
  color: theme.palette.text.primary,
  maxHeight: '148px',
  textDecoration: 'none !important',
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  display: 'flex',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  gap: theme.spacing(1),
  cursor: 'pointer',
  border: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create(['background-color'], {
    duration: theme.transitions.duration.short,
  }),
  '&:hover': {
    backgroundColor: alpha(
      theme.palette.action.hover,
      theme.palette.action.hoverOpacity,
    ),
  },
  '&.selected': {
    backgroundColor: alpha(
      theme.palette.action.active,
      theme.palette.action.activatedOpacity,
    ),
  },
}));
